import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { List } from 'immutable';
import { BaseCommonComponent, BaseDataService, ModalService, NotificationService, QueryParameter, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-izmeni-komitenta',
  templateUrl: './izmeni-komitenta.component.html'
})
export class IzmeniKomitentaComponent extends BaseCommonComponent implements OnInit {

 

  @Input() Parameters;
  parameterListZaKomitente: List<QueryParameter> = List([]);
  Domaca: QueryParameter = new QueryParameter();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected activeModal: NgbActiveModal,
    protected translateService: TranslateService,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService
  ) {
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);
   }

  ngOnInit() {
    this.baseFormGroup = new FormGroup({
      KomitentID1: new FormControl(''),
      KomitentID2: new FormControl('')
    });
    this.addValidatorToFc("KomitentID1",Validators.required,'required',"IZMENAKOMITENTA.KOMITENT1.VALIDATION.REQUIRED");
    this.addValidatorToFc("KomitentID2",Validators.required,'required',"IZMENAKOMITENTA.KOMITENT2.VALIDATION.REQUIRED");    this.Domaca.Name="Domaca";
    this.Domaca.Value = "true";
    this.parameterListZaKomitente = this.parameterListZaKomitente.push(this.Domaca);
    this.baseFormGroup.patchValue({KomitentID1 : this.Parameters[0].Value});
    this.baseFormGroup.get('KomitentID1').updateValueAndValidity();

  }

  Close(){
    this.activeModal.close();
  }

  Save(){
    this.submitted = true;  
    if(this.baseFormGroup.valid){
      let komitentID2 = this.baseFormGroup.get('KomitentID2').value;
      this.submitted = false;  
      this.activeModal.close(komitentID2);
    }
    this.submitted = false;  
    
  }

}
